// src/pages/UsersAdmin.jsx

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllUsers, updateUser, deleteUser } from "../utils/userUtils";
import { getCurrentUser } from "../utils/auth";
import "../styles/styles.css";

const UsersAdmin = () => {
  const navigate = useNavigate();
  const [current] = useState(() => getCurrentUser());
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (!current || current.role !== "admin") {
      navigate("/");
    } else {
      setUsers(getAllUsers());
    }
  }, [current, navigate]);

  const handleRoleChange = (email, newRole) => {
    updateUser(email, { role: newRole });
    setUsers(getAllUsers());
  };

  const handleDelete = (email) => {
    if (window.confirm(`¿Eliminar la cuenta de ${email}?`)) {
      deleteUser(email);
      setUsers(getAllUsers());
    }
  };

  return (
    <div className="admin-container">
      <h2>Administración de Usuarios</h2>
      {users.length === 0 ? (
        <p style={{ color: "var(--color-text-secondary)" }}>No hay usuarios.</p>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Rol</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {users.map(({ email, role }) => (
              <tr key={email}>
                <td>{email}</td>
                <td>{role}</td>
                <td>
                  <select
                    value={role}
                    onChange={(e) => handleRoleChange(email, e.target.value)}
                  >
                    <option value="user">Usuario</option>
                    <option value="creator">Creador</option>
                    <option value="admin">Administrador</option>
                  </select>
                  <button
                    className="btn-small btn-reject"
                    style={{ marginLeft: "0.5rem" }}
                    onClick={() => handleDelete(email)}
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UsersAdmin;
